import "core-js/modules/es7.array.includes.js";
import { getProductType } from '@nerdwallet/marketplace/selectors/common';
import { couldMonetize } from '@nerdwallet/marketplace/selectors/banking';
export var productTypesWithThrottling = ['banking'];
/**
 * Determine whether this offer is throttled.
 * @param {object} marketplaceEntity An entity from Marketplace (offer, product, or institution).
 * @note This is a per-vertical opt-in feature. By default, isThrottled() will return false for all verticals
 * isThrottle() will only return true if an offer CAN monetize, but SHOULD NOT, as determined using the couldMonetize() and shouldMonetize selectors
 * Right now, the shouldMonetize() function is used indirectly, via the isNonMonetizing() call in src/mappings/index.js
 * TODO Move this into nwjs-marketplace as part of - https://nerdwallet.atlassian.net/browse/SHOP-14396
 */

export var isThrottled = function isThrottled(marketplaceEntity) {
  if (!productTypesWithThrottling.includes(getProductType(marketplaceEntity))) {
    return false;
  }

  return couldMonetize(marketplaceEntity);
};